var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -700.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Ship",
    transform: "translate(2734.000000, 700.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L27.0986145,25.937 C26.6423925,26.603 25.8870249,27 25.0796319,27 L25.0796319,27 L2.43361023,27 C1.00291392,27 -0.0866163522,25.783 0.00542844542,24.394 L0.00542844542,24.394 L0.984905151,18 L32,18 Z M23.4958611,21 C22.6674579,21 21.9951307,21.672 21.9951307,22.5 C21.9951307,23.328 22.6674579,24 23.4958611,24 C24.3242643,24 24.9965915,23.328 24.9965915,22.5 C24.9965915,21.672 24.3242643,21 23.4958611,21 Z M17.4929395,21 C16.6635358,21 15.9922091,21.672 15.9922091,22.5 C15.9922091,23.328 16.6635358,24 17.4929395,24 C18.3213427,24 18.9936699,23.328 18.9936699,22.5 C18.9936699,21.672 18.3213427,21 17.4929395,21 Z M11.4900179,21 C10.6606143,21 9.98928753,21.672 9.98928753,22.5 C9.98928753,23.328 10.6606143,24 11.4900179,24 C12.3194216,24 12.9907483,23.328 12.9907483,22.5 C12.9907483,21.672 12.3194216,21 11.4900179,21 Z M5.48709634,21 C4.65769267,21 3.98636594,21.672 3.98636594,22.5 C3.98636594,23.328 4.65769267,24 5.48709634,24 C6.3165,24 6.98782673,23.328 6.98782673,22.5 C6.98782673,21.672 6.3165,21 5.48709634,21 Z M26.4973219,15 L27.9980523,17 L1.16299182,17 L1.47614423,15 L26.4973219,15 Z M24.2462263,12 L25.7469567,14 L1.63222019,14 L1.9453726,12 L24.2462263,12 Z M7.98851376,6 L10.0435139,9 L10.9899746,9 L10.9899746,6 L13.9914353,6 L15.9924092,9 L21.9513094,9 L22.1163897,9.162 L23.4960612,11 L2.10264915,11 L2.41580156,9 L4.98705297,9 L4.98705297,6 L7.98851376,6 Z",
    id: 63
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityShip);
export default __webpack_public_path__ + "static/media/transport-and-utility-ship.2c1e8101.svg";
export { ForwardRef as ReactComponent };